var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import cn from "classnames";
import { Button } from "@components/ui";
import { useStore } from "@context/store";
import { useUI } from "@context/ui";
export var ListItemSkeleton = function () {
    return (_jsxs("div", __assign({ className: "animate-pulse opacity-40 space-y-2 px-6 py-4" }, { children: [_jsx("div", { className: "h-4 bg-decent rounded w-3/5" }, void 0),
            _jsx("div", { className: "h-4 bg-decent rounded w-4/5" }, void 0)] }), void 0));
};
var ListItem = function (_a) {
    var onClick = _a.onClick, onConfirm = _a.onConfirm, disabled = _a.disabled, title = _a.title, description = _a.description, active = _a.active, content = _a.content;
    var rootClassName = cn("cursor-pointer", {
        "bg-active": active,
        "opacity-40": disabled,
    });
    return (_jsxs("li", __assign({ className: rootClassName, onClick: onClick }, { children: [_jsxs("div", __assign({ className: "px-5 py-3" }, { children: [_jsx("div", __assign({ className: "" }, { children: title }), void 0),
                    _jsx("div", __assign({ className: "text-sm" }, { children: description }), void 0)] }), void 0),
            active && (_jsxs("div", __assign({ className: "px-5 py-3 flex flex-col" }, { children: [_jsx("div", { children: content }, void 0),
                    _jsx(Button, __assign({ primary: true, disabled: disabled, onClick: onConfirm, className: "self-end" }, { children: "Confirm" }), void 0)] }), void 0))] }), void 0));
};
var OpeningHours = function (_a) {
    var openingHours = _a.openingHours;
    return openingHours ? (_jsx("div", __assign({ className: "text-xs" }, { children: openingHours.map(function (_a, index) {
            var day = _a.day, timeEntries = _a.timeEntries;
            return (_jsx("div", { children: day + " " + timeEntries.map(function (_a) {
                    var startTime = _a.startTime, endTime = _a.endTime;
                    return startTime + "-" + endTime;
                }) }, "opening-hours-" + index));
        }) }), void 0)) : (_jsx(_Fragment, {}, void 0));
};
var List = function (_a) {
    var locations = _a.locations, selected = _a.selected, setSelected = _a.setSelected;
    var setLocation = useStore().setLocation;
    var _b = useUI(), nextStep = _b.nextStep, closeModal = _b.closeModal;
    var handleSelected = function (value) {
        setSelected(value);
    };
    var handleConfirm = function () {
        var location = locations[selected];
        var locationPicked = (function (_a) {
            var id = _a.id, name = _a.name, address = _a.address, price = _a.price, slots = _a.slots;
            return ({
                id: id,
                name: name,
                address: address,
                price: price,
                slots: slots,
            });
        })(location);
        setLocation(locationPicked);
        closeModal();
        nextStep();
    };
    return (_jsx("ul", __assign({ className: "w-full list-none p-0 m-0 divide-y divide-gray-200" }, { children: locations.map(function (_a, index) {
            var openingHours = _a.openingHours, id = _a.id, available = _a.available, location = __rest(_a, ["openingHours", "id", "available"]);
            return (_jsx(ListItem, { disabled: !available, onClick: handleSelected.bind(_this, index), onConfirm: handleConfirm, title: "" + location.name, description: location.address.address1 + " " + location.address.city + " " + location.address.zipCode, active: selected === index, content: _jsx(OpeningHours, { openingHours: openingHours }, void 0) }, id));
        }) }), void 0));
};
export default memo(List, function (prev, next) {
    if (prev.selected !== next.selected) {
        return false;
    }
    if (prev.locations.length !== next.locations.length) {
        return false;
    }
    return true;
});
